import HttpService from '@/endpoints/HttpService';
import {
  LockerRoomDrawingBench,
  LockerRoomDrawingBenchRequest,
  LockerRoomDrawingBenchTransformBatchRequest,
} from '@/models/lockers/lockerRoomDrawingBench';

const baseUrl = `${process.env.VUE_APP_API_PREFIX}LockerRoomDrawingBenches`;

export default class LockerRoomDrawingBenchesService {
  public static async getBenchesForRoom(roomId: string): Promise<LockerRoomDrawingBench[]> {
    const response = await HttpService.get(`${baseUrl}/${roomId}`);
    return response.data.entities;
  }

  public static async createBench(request: LockerRoomDrawingBenchRequest): Promise<LockerRoomDrawingBench[]> {
    const response = await HttpService.post(baseUrl, request);
    return response.data.entities;
  }

  public static async deleteBench(benchId: number): Promise<LockerRoomDrawingBench[]> {
    const response = await HttpService.delete(`${baseUrl}/${benchId}`);
    return response.data.entities;
  }

  public static async duplicateBench(benchId: number): Promise<LockerRoomDrawingBench[]> {
    const response = await HttpService.post(`${baseUrl}/${benchId}/duplicate`);
    return response.data.entities;
  }

  public static async updateBenchTransforms(request: LockerRoomDrawingBenchTransformBatchRequest): Promise<void> {
    await HttpService.put(baseUrl, request);
  }
}
